

import { useSessionMutation as useMutation } from "@/lib/query/core/use-session-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { changePrivateSession } from "./privateSessionChange";

export function useLogoutMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: () =>
      changePrivateSession(queryClient, () => apiJsonClient<unknown>(endpoints.admin.auth.logout, {
        method: "POST",
      })),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
